import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Tabs from '../../../../Components/Tabs';
import TaskCategoryScreen from './TaskCategory';
import TaskTypeScreen from './TaskType';
import TaskCheckScreen from './TaskChecks';
import TaskManagementController from '../../../Controllers/AdminManagementScreens/TaskManagement/TaskManagementController';

const TaskManagementScreen = () => {

    const { state } = useLocation();
    const [selectedTab, setSelectedTab] = useState(state?.selectedTab || 0);

    const{
        categories,        
        loading,
        error,
        servicesSearchList,
        searchLoading,
        searchError,
        categoryRefresh,
        subCategories,
        subCatError,
        subCatLoading,
        subCategoryRefresh,
        typeCheckList,
        typeCheckLoading,
        typeCheckError,
        typeCheckRefresh
    }= TaskManagementController();

    const handleTabChange = (index) => {
        setSelectedTab(index);
    };

    return (
        <div style={styles.mainContent}>
            <div className='title-container' style={{paddingBottom:20}}>
                <h2 className='title'>Manage Services</h2>
            </div>

            <div>
                <Tabs tabs={['Service','Service Category','Task Checks']}
                selectedIndex={selectedTab}
                onTabChange={handleTabChange}>
                    <TaskCategoryScreen categories={categories} loading={loading} error={error} onRefresh={categoryRefresh}/>
                    <TaskTypeScreen  servicesSearchList={servicesSearchList} subCategories={subCategories} loading={subCatLoading} error={subCatError} searchError={searchError} searchLoading={searchLoading} onRefresh={subCategoryRefresh}/>
                    <TaskCheckScreen servicesSearchList={servicesSearchList} typeCheckList={typeCheckList} loading={typeCheckLoading} error={typeCheckError} searchError={searchError} searchLoading={searchLoading} onRefresh={typeCheckRefresh}/>
                </Tabs>
            </div>

        </div>


    )

};

const styles = {
    mainContent: {
        width: '93%',
        margin: 'auto'
    }

}

export default TaskManagementScreen;